export const STATUS = {
  PENDING   : 'pending',
  SCHEDULED : 'scheduled'
}

export const COURIER = {
  MERCHANT   : 'merchant',
  EASYPARCEL : 'easyparcel',
  TIKI       : 'tiki',
  JNE        : 'jne',
  GRAB       : 'grab',
  GOJEK      : 'gojek',
  SICEPAT    : 'sicepat',
  KGXPRESS   : 'kgxpress'
}

export const SHIPMENT_TYPE = {
  REGULER         : 'reguler',
  SAME_DAY        : 'same_day',
  ECONOMY         : 'economy',
  MERCHANT_PICKUP : 'merchant_pickup'
}

/** Shipment type only if courier is not merchant*/
export const NON_MERCHANT_SHIPMENT_TYPE = {
  [SHIPMENT_TYPE.REGULER.toUpperCase()]  : SHIPMENT_TYPE.REGULER,
  [SHIPMENT_TYPE.SAME_DAY.toUpperCase()] : SHIPMENT_TYPE.SAME_DAY,
  [SHIPMENT_TYPE.ECONOMY.toUpperCase()]  : SHIPMENT_TYPE.ECONOMY
}

/** Shipment type only if courier is merchant */
export const MERCHANT_SHIPMENT_TYPE = {
  [SHIPMENT_TYPE.MERCHANT_PICKUP.toUpperCase()]: SHIPMENT_TYPE.MERCHANT_PICKUP
}